import * as React from "react";
import { initializeIcons } from '@fluentui/react';
import { Button, Divider, Dropdown, Flex, FlexItem, Input, Text, Tooltip, Toolbar } from "@fluentui/react-northstar";
import { AddIcon, CalendarIcon, EditIcon, ExpandIcon, FilterIcon, PollIcon, SearchIcon, SettingsIcon, ShareGenericIcon, WindowRestoreIcon, TenantPersonalIcon } from '@fluentui/react-icons-northstar';
import { withTranslation, WithTranslation } from "react-i18next";
import { IServentias } from '../../../interfaces/serventias';
import { formatDataNumber } from "../../../helpers/format-numbers";
import Roles from "../../../constants/roles";
import ServentiaFilters from '../../../constants/serventias-filters';
import i18n from "../../../i18n";
import { app } from "@microsoft/teams-js";

interface IToolbarProps extends WithTranslation {
    items: IServentias[];
    isAdmin: boolean;
    role: string;
    setup: boolean | null;
    onEditBalcaoVirtual: Function;
    selectedItem: any;
    searchParam: any;
    agendar: Function;
    copyEnderecoPublicoToClipboard: Function;
    onNewBalcaoVirtual: Function;
    configAppSettings: Function;
    reportUrl: string | undefined;
    dashboardTask: Function;
    homeTask: Function;
    totalFilterChecked: number;
    clearFilter: Function;
    itemsSecaoFilter: ISecaoJudiciaria[];
    renderFilters: Function;
    index: number;
    search: Function;
    filterView: Function;
    selectedViewFilterLocale: string | null;
    totalMetrics: any;
    collapseCharts: Function;
    collapsed: boolean;
    theme: string;
    pinnedAncoras: any[];
}

export interface ISecaoJudiciaria {
    name: string;
    isSelected: boolean;
}

const ToolbarHome: React.FunctionComponent<IToolbarProps> = props => {
    initializeIcons();
    const localize = props.t;

    const [filterActive, setFilterActive] = React.useState(false);
    const [viewFilterActive, setViewFilterActive] = React.useState(false);

    return (
        <Flex
            space="between"
            className="toolbar-serventias"
            styles={{
                position: "sticky",
                top: 0,
                padding: "1.25rem 1.25rem 1.25rem 0",
                margin: "1.25rem 0",
                zIndex: 999,
            }}>
            <Flex vAlign="center">
                {props.items.some(item => item.isSelected == true) ?
                    <Toolbar
                        aria-label="toolbar-header"
                        items={[
                            {
                                content: <div
                                    hidden={(!props.isAdmin && (props.role == Roles.leitor || props.role == Roles.atendente)) || !props.setup}
                                    onClick={() => props.onEditBalcaoVirtual(props.selectedItem.ancora)}
                                    className="item-header-toolbar">
                                    <EditIcon className="align-icon" outline />
                                    <Text content={localize("Editar")} />
                                </div>,
                                key: 'edit',
                                kind: "custom",
                                fitted: "horizontally"
                            },
                            {
                                content: <div className="item-header-toolbar" onClick={() => {
                                    const url = window.location.ancestorOrigins[0].includes("cloud") ?
                                        `https://teams.cloud.microsoft/l/entity/${props.searchParam.get("appId")}/painel?context=${encodeURI('{"subEntityId": "' + props.selectedItem.ancora + ', ' + props.selectedItem.serventia + '"}')}` :
                                        `https://teams.microsoft.com/l/entity/${props.searchParam.get("appId")}/painel?context=${encodeURI('{"subEntityId": "' + props.selectedItem.ancora + ', ' + props.selectedItem.serventia + '"}')}`
                                    app.openLink(url)
                                      
                                }}>
                                    <ShareGenericIcon className="align-icon" outline />
                                    <Text content={localize("MostrarAtendimento")} />
                                </div>,
                                key: 'painel-atendimento',
                                kind: "custom",
                                fitted: "horizontally"
                            },
                            {
                                content: <div
                                    hidden={(!props.isAdmin && (props.role == Roles.leitor)) || !props.setup || !props.selectedItem.scheduledQueue}
                                    className="item-header-toolbar" onClick={() => props.agendar(props.selectedItem.ancora)}>
                                    <CalendarIcon className="align-icon" outline />
                                    <Text content={localize("NovoAgendamento")} />
                                </div>,
                                key: 'novo-agendamento',
                                kind: "custom",
                                fitted: "horizontally"
                            },
                            {
                                content: <div
                                    hidden={!props.isAdmin && (props.role == Roles.leitor || props.role == Roles.atendente)}
                                    className="item-header-toolbar"
                                    onClick={() => props.copyEnderecoPublicoToClipboard(props.selectedItem.ancora)}
                                >
                                    <WindowRestoreIcon className="align-icon" outline />
                                    <Text content={localize("CopiarURLExterna")} />
                                </div>,
                                key: 'copiar-url',
                                kind: "custom",
                                fitted: "horizontally"
                            },
                        ]}
                    />
                    :
                    <Flex gap="gap.large">
                        <FlexItem align="center">
                            <Dropdown
                                className="items-visualizacao"
                                fluid={true}
                                items={[
                                    localize("FiltroAtivos"),
                                    localize("FiltroExcluidos"),
                                    localize("FiltroTodos"),
                                    localize("FiltroFavoritos"),
                                ]}
                                placeholder={localize("Visualizacao")}
                                highlightedIndex={props.index}
                                checkable
                                inverted
                                getA11ySelectionMessage={{
                                    onAdd: (item: any) => {
                                        return props.filterView(item);
                                    }
                                }}
                                value={(!props.selectedViewFilterLocale && !!props.pinnedAncoras.length) ? ServentiaFilters.favoritos : props.selectedViewFilterLocale}
                            />
                        </FlexItem>
                        <FlexItem align="center">
                            <Flex className="totals" gap="gap.small" vAlign="center" hAlign="center">
                                <Text size="medium" content={localize("TotalRegistradas")} />
                                <Tooltip
                                    trigger={
                                        <Text size="medium" weight="bold" content={formatDataNumber(props.totalMetrics?.totalSolicitacoes)} />
                                    }
                                    content={new Intl.NumberFormat(i18n.language).format(props.totalMetrics?.totalSolicitacoes)}
                                    position="above"
                                    align="start"
                                />

                                <Text size="medium" content="|" />

                                <Text size="medium" content={localize("TotalRealizados")} />
                                <Tooltip
                                    trigger={
                                        <Text size="medium" weight="bold" content={formatDataNumber(props.totalMetrics?.totalAtendimentos)} />
                                    }
                                    content={new Intl.NumberFormat(i18n.language).format(props.totalMetrics?.totalAtendimentos)}
                                    position="above"
                                    align="start"
                                />

                                <Text size="medium" content="|" />

                                <Text size="medium" content={localize("TotalAtendentes")} />
                                <Tooltip
                                    trigger={
                                        <Text size="medium" weight="bold" content={formatDataNumber(props.totalMetrics?.totalAtendentesAtivos)} />
                                    }
                                    content={new Intl.NumberFormat(i18n.language).format(props.totalMetrics?.totalAtendentesAtivos)}
                                    position="above"
                                    align="start"
                                />
                            </Flex>
                        </FlexItem>
                    </Flex>
                }
            </Flex>
            <Flex gap="gap.small">
                <FlexItem>
                    <Input inverted icon={<SearchIcon />} className="search-box" placeholder={localize("Pesquisar")} onChange={(e: any) => props.search(e)} />
                </FlexItem>

                <Toolbar
                    className="toolbar-home"
                    items={[
                        {
                            icon: (
                                <FilterIcon
                                    {...{
                                        outline: true,
                                    }}
                                />
                            ),
                            key: 'filter',
                            active: filterActive,
                            className: "icon-only",
                            popup: {
                                content: <div className="div-popup-filter">
                                    <Flex>
                                        <FlexItem>
                                            <Text content={`${localize("Filtro")} (${props.totalFilterChecked})`} />
                                        </FlexItem>
                                        <FlexItem push>
                                            <Text className={`${props.theme} clear-filter`} content={localize("Limpar")} onClick={() => props.clearFilter()} />
                                        </FlexItem>
                                    </Flex>

                                    <Flex inline style={{ display: "block" }}>
                                        <FlexItem>
                                            <Divider />
                                        </FlexItem>
                                    </Flex>

                                    <div className="popup-items-filter">
                                        {props.itemsSecaoFilter.map((item: any, index: number) => props.renderFilters(item, index))}
                                    </div>
                                </div>,
                                onOpenChange: () => {
                                    setFilterActive(!filterActive)
                                },
                            },
                        },
                        {
                            icon: (
                                <ExpandIcon
                                    {...{
                                        outline: true,
                                    }}
                                />
                            ),
                            key: 'viewFilter',
                            active: !props.collapsed,
                            className: "icon-only",
                            onClick: () => props.collapseCharts(!props.collapsed),
                        },
                        {
                            key: 'divider2',
                            kind: 'divider',
                            hidden: !props.isAdmin
                        },
                        {
                            key: 'public',
                            kind: 'custom',
                            content: <Tooltip
                                trigger={
                                    <Button
                                        className="icon-only"
                                        hidden={(!props.isAdmin && (props.role == Roles.leitor || props.role == Roles.atendente)) || !props.setup}
                                        iconOnly
                                        text
                                        icon={<TenantPersonalIcon outline />}
                                        onClick={() => props.homeTask()}
                                    />
                                }
                                content={localize("PaginaPublica")}
                                position="below"
                                align="center"
                            />,
                            fitted: 'horizontally',
                        },
                        {
                            key: 'dashboard',
                            kind: 'custom',
                            content: <Tooltip
                                trigger={
                                    <Button
                                        className="icon-only"
                                        hidden={!props.isAdmin || !props.setup || !props.reportUrl}
                                        iconOnly
                                        text
                                        icon={<PollIcon outline />}
                                        onClick={() => props.dashboardTask()}
                                    />
                                }
                                content={localize("Dashboard")}
                                position="below"
                                align="center"
                            />,
                            fitted: 'horizontally',
                        },
                        {
                            key: 'settings',
                            kind: 'custom',
                            content: <Tooltip
                                trigger={
                                    <Button
                                        className="icon-only"
                                        hidden={!props.isAdmin}
                                        iconOnly
                                        text
                                        icon={<SettingsIcon outline />}
                                        onClick={() => props.configAppSettings()}
                                    />
                                }
                                content={localize("Configuracao")}
                                position="below"
                                align="center"
                            />,
                            fitted: 'horizontally',
                        },
                        {
                            key: 'unit',
                            kind: 'custom',
                            content: <Button
                                hidden={(!props.isAdmin && (props.role == Roles.leitor || props.role == Roles.atendente)) || !props.setup}
                                primary
                                icon={<AddIcon outline size="small" />}
                                content={localize("NovoBalcaoVirtual")}
                                iconPosition="before"
                                onClick={() => props.onNewBalcaoVirtual()}
                                className="button-ms-color"
                                styles={{ marginLeft: ".5rem" }}
                            />,
                            fitted: 'horizontally',
                        },
                    ]}
                />
            </Flex>
        </Flex>
    );
};

const toolbarWithTranslation = withTranslation()(ToolbarHome);
export default toolbarWithTranslation;